import { AppResourcePage } from './app-resource-base';
import { branchSwitchOnResource } from './helpers/branch-switch';
import { createConcurrencyCheck, ResourceLocker } from '../common/resource-lock';
import { createProjectView, ProjectLock } from '../projects/project-ui-adapter';
import { customElement } from 'lit/decorators.js';
import { getProjectContainer, getProjectContainerManager } from '../projects/project-ui-container-manager';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { LangAppProjectPage } from '../../../localization/scripts/dealer-franchisee/pages/app-project-lang';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { ProjectContainerManager } from '../../projects/data/project-container';

@customElement('app-project')
export class AppProjectPage extends AppResourcePage {
  pm?: ProjectContainerManager;

  async redirectPath(): NullPromise<string> {
    return Promise.resolve('/projects');
  }

  async createModalEditor(id: string): NullPromise<ModalViewBase> {
    const container = getProjectContainer(id);
    if (isEmptyOrSpace(id)) id = container.projectId;

    this.pm = getProjectContainerManager(container, () => !this.lock?.isLockOwner);
    if (!(await this.pm.needsProject())) return null;
    const branchId = this.pm.project.projectOwnerId;
    if (!(await branchSwitchOnResource(branchId, LangAppProjectPage.projectGlossary()))) return null;

    return await createProjectView(this.pm);
  }

  meta() {
    return {
      title: () => LangAppProjectPage.projectEditorTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createLock(id: string): ResourceLocker | undefined {
    const lockRevokedEvent = async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/projects');
    };

    // Create concurrency check that ensures local data is loaded and compares recordVersion with server
    const concurrencyCheck = createConcurrencyCheck('PROJECT.PROJECT', id, async () => {
      await this.pm?.needsProject();
      return this.pm?.project?.recordVersion ?? '';
    });

    return new ProjectLock(id, lockRevokedEvent, concurrencyCheck);
  }
}
